// import { useState, useEffect, useRef } from "react";

// const useScrollDirection = () => {
//   const [scrollDir, setScrollDir] = useState("up");
//   const threshold = 50;
//   const lastScrollY = useRef(0);

//   useEffect(() => {
//     const updateScrollDir = () => {
//       const currentScrollY = window.scrollY;

//       // Ignorar pequeños movimientos dentro del umbral
//       if (Math.abs(currentScrollY - lastScrollY.current) < threshold) {
//         return;
//       }

//       // Determinar la dirección
//       const newDirection = currentScrollY > lastScrollY.current ? "down" : "up";

//       // Solo actualizar si la dirección ha cambiado
//       if (newDirection !== scrollDir) {
//         setScrollDir(newDirection);
//       }

//       lastScrollY.current = currentScrollY > 0 ? currentScrollY : 0;
//     };

//     window.addEventListener("scroll", updateScrollDir);

//     return () => {
//       window.removeEventListener("scroll", updateScrollDir);
//     };
//   }, [scrollDir]);

//   return scrollDir;
// };

// export default useScrollDirection;
import { useState, useEffect, useRef } from "react";

// MODIFICACIÓN: Acepta un prop para indicar si el scroll es interno/programático
const useScrollDirection = (isInternalScroll) => {
  // <-- Se agrega prop
  const [scrollDir, setScrollDir] = useState("up");
  const threshold = 50;
  const lastScrollY = useRef(0);

  useEffect(() => {
    const updateScrollDir = () => {
      // CAMBIO CLAVE: Ignorar la lógica si hay un scroll interno activo
      if (isInternalScroll) {
        return; // Detiene la ejecución si estamos haciendo un scroll programático
      }

      const currentScrollY = window.scrollY; // Ignorar pequeños movimientos dentro del umbral

      if (Math.abs(currentScrollY - lastScrollY.current) < threshold) {
        return;
      } // Determinar la dirección

      const newDirection = currentScrollY > lastScrollY.current ? "down" : "up"; // Solo actualizar si la dirección ha cambiado

      if (newDirection !== scrollDir) {
        setScrollDir(newDirection);
      }

      lastScrollY.current = currentScrollY > 0 ? currentScrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDir);

    return () => {
      window.removeEventListener("scroll", updateScrollDir);
    };
  }, [scrollDir, isInternalScroll]); // <-- Se añade la dependencia isInternalScroll

  return scrollDir;
};

export default useScrollDirection;
